var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M6.0001 3C5.3371 3 4.8001 3.537 4.8001 4.2V13.8C4.8001 14.463 5.3371 15 6.0001 15H12.0001C12.6631 15 13.2001 14.463 13.2001 13.8V4.2C13.2001 3.537 12.6631 3 12.0001 3H6.0001ZM1.8001 4.2C1.1371 4.2 0.600098 4.737 0.600098 5.4V12.6C0.600098 13.263 1.1371 13.8 1.8001 13.8H3.6001V12H1.8001C1.8001 10.2372 3.3475 10.7375 3.6001 9.97969V9.47344C3.6001 9.47344 3.12922 9.03053 3.09502 8.72813C3.09502 8.72813 2.8501 8.63629 2.8501 8.25469C2.8501 8.05789 2.94385 8.01211 2.94385 8.01211C2.94385 8.01211 2.7376 7.726 2.7376 7.3582C2.7376 6.7186 3.09307 6.2891 3.60127 6.1043V4.2H1.8001ZM14.4001 4.2V6.3C14.9173 6.3 15.2251 6.77196 15.2251 7.38516C15.2251 7.69116 15.0563 8.01211 15.0563 8.01211C15.0563 8.01211 15.1501 8.04409 15.1501 8.25469C15.1501 8.55829 14.9052 8.72813 14.9052 8.72813C14.871 9.03113 14.4001 9.47344 14.4001 9.47344V9.97852C14.6527 10.7363 16.2001 10.2306 16.2001 11.9988H14.4001V13.7988H16.2001C16.8631 13.7988 17.4001 13.2618 17.4001 12.5988V5.4C17.4001 4.737 16.8631 4.2 16.2001 4.2H14.4001ZM9.0001 6C9.3805 6 9.6001 6.3 9.6001 6.3C10.1173 6.3 10.4251 6.77196 10.4251 7.38516C10.4251 7.69116 10.2563 8.01211 10.2563 8.01211C10.2563 8.01211 10.3501 8.04409 10.3501 8.25469C10.3501 8.55829 10.1052 8.72813 10.1052 8.72813C10.071 9.03113 9.6001 9.47344 9.6001 9.47344V9.97852C9.8527 10.7363 11.4001 10.2306 11.4001 11.9988H6.6001C6.60084 10.2375 8.14756 10.7373 8.4001 9.97969V9.47344C8.4001 9.47344 7.92922 9.03053 7.89502 8.72813C7.89502 8.72813 7.6501 8.63629 7.6501 8.25469C7.6501 8.05789 7.74385 8.01211 7.74385 8.01211C7.74385 8.01211 7.5376 7.726 7.5376 7.3582C7.537 6.487 8.1925 6 9.0001 6Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }